<template>
  <div>
    <b-textarea
      v-model="comment"
      label="Коментар"
      placeholder="Введіть коментар"
      :error-messages="getErrorMessages(v$.comment)"
      rows="3"
      @blur="v$.comment.$touch()"></b-textarea>
  </div>
</template>

<script setup lang="ts">
import { BTextarea } from 'best-modules/components'
import { Dialog } from '@/dialog'
import { ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { documentRevision } from '@/requests/document'
import { getErrorMessages } from 'best-modules/utils'

defineOptions({
  name: 'DocumentRevision',
})

const props = defineProps<{
  dialog: Dialog
}>()

const comment = ref<string>('')

const v$ = useVuelidate({ comment: { required } }, { comment })

const submit = () => {
  return documentRevision(props.dialog.dialogData.documentId, comment.value)
}

defineExpose({
  v$,
  submit,
})
</script>
